import {Text} from '@wix/wix-ui-tpa/cssVars'
import classNames from 'classnames'
import React from 'react'
import {SummaryRowProps} from './interfaces'
import {classes} from './summary-row.st.css'

export const SummaryRow = ({label, value, dataHook, size = 'regular', textValue = false}: SummaryRowProps) =>
  value ? (
    <div className={classNames(classes.row, {[classes.large]: size === 'regular'})} data-hook={dataHook}>
      <Text className={classes.label}>{label}</Text>
      <Text className={textValue ? classes.label : classes.amount}>{value}</Text>
    </div>
  ) : null
